module.exports = __webpack_public_path__ + "img/voided.be405dd0.svg";